import axios from "axios";
import { store } from "@/redux/store";
import {
    startLoading,
    showLoading,
    endLoading,
} from "@/redux/LoadingSlice";


let delayTimer = null;
const DELAY = 500;

export const axiosInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
});


axiosInstance.interceptors.request.use((config) => {
    store.dispatch(startLoading());

    if (!delayTimer) {
        delayTimer = setTimeout(() => {
            store.dispatch(showLoading());
        }, DELAY);
    }

    return config;
});

axiosInstance.interceptors.response.use(
    (res) => {
        store.dispatch(endLoading());

        if (delayTimer) {
            clearTimeout(delayTimer);
            delayTimer = null;
        }
        return res;
    },
    (err) => {
        store.dispatch(endLoading());

        if (delayTimer) {
            clearTimeout(delayTimer);
            delayTimer = null;
        }
        return Promise.reject(err);
    }
);
